// The SPA's deploy-detection signal is its OWN build manifest, version.json,
// emitted into the bundle root by vite.config.ts (emitVersionJson) with the
// build's release SHA. We poll it same-origin — NOT the API's /api/v1/version.
//
// Why not the API: since the smart-deploy split, the SPA (go.sportadmin.io)
// and the API deploy as independent images. A frontend-only deploy doesn't
// change the API's build SHA, and an API-only deploy doesn't change the SPA
// bundle — so the API version is the wrong thing to compare the SPA against.
// version.json tracks exactly this bundle, is served fresh by the SPA's own
// origin, and needs no auth (works on the pre-login landing page).

export interface VersionResponse {
  /** Release SHA baked into the deployed bundle (empty in local dev builds). */
  release: string;
}

export async function fetchVersion(): Promise<VersionResponse> {
  // cache: 'no-store' so we always see the freshly deployed manifest rather
  // than a cached copy — version.json is tiny and intentionally uncacheable.
  const res = await fetch('/version.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`version.json responded ${res.status}`);
  return (await res.json()) as VersionResponse;
}
